// extracted by mini-css-extract-plugin
export default {"anchor":"Tooltip_anchor__Gyue3","tooltip":"Tooltip_tooltip__tIirw"};